import { Button } from '@/components/ui/button';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function DesktopFooter() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const handleCreate = () => {
    form.handleSubmit();
  };

  return (
    <div className="px-8 py-4 bg-neutrals-100 border-t border-neutrals-300 flex sticky bottom-0 ">
      {ctx.hasPrevious() && (
        <Button
          variant="outline"
          onClick={() => {
            ctx.previous();
          }}>
          {t('domain.mitarbeiter.create.navigationZurueck')}
        </Button>
      )}
      {ctx.hasNext() && (
        <Button
          className="ml-auto"
          onClick={() => {
            ctx.next();
          }}>
          {t('domain.mitarbeiter.create.navigationWeiter')}
        </Button>
      )}
      {ctx.state.steps[ctx.state.currentStepIndex].type === 'summary' && (
        <Button className="ml-auto" onClick={handleCreate}>
          {t('domain.mitarbeiter.create.submitButton')}
        </Button>
      )}
    </div>
  );
}

export function MobileFooter() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const handleCreate = () => {
    form.handleSubmit();
  };
  return (
    <div className="mt-auto p-4 border-t border-neutrals-300">
      {ctx.hasNext() ? (
        <Button className="w-full" onClick={() => ctx.next()}>
          {t('domain.mitarbeiter.create.navigationWeiter')}
        </Button>
      ) : (
        <Button className="w-full" onClick={handleCreate}>
          {t('domain.mitarbeiter.create.submitButton')}
        </Button>
      )}
    </div>
  );
}
